/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CorePresignedUploadResponseDto } from '../../models/core-presigned-upload-response-dto';
import { CoreRequestProjectUploadUrlDto } from '../../models/core-request-project-upload-url-dto';

export interface DocumentsControllerGenerateProjectUploadUrls$Params {

/**
 * Tenant identifier for multi-tenancy isolation.
 */
  tenant: string;
      body: CoreRequestProjectUploadUrlDto
}

export function documentsControllerGenerateProjectUploadUrls(http: HttpClient, rootUrl: string, params: DocumentsControllerGenerateProjectUploadUrls$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CorePresignedUploadResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, documentsControllerGenerateProjectUploadUrls.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CorePresignedUploadResponseDto>>;
    })
  );
}

documentsControllerGenerateProjectUploadUrls.PATH = '/o2-core/documents/{tenant}/project-attachments/upload-url';
